// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/var/www/crm/uksirius/src/models/global';

export const models = {
model_1: { namespace: 'global', model: model_1 },
} as const
